// ------------------------ COMMON ---------------------------- //

export const TOGGLE_PROGLANG_LIST = 'toggle_proglang_list'
export const TOGGLE_LANGUAGE_LIST = 'toggle_language_list'
export const SELECT_PROGLANG = 'select_programming_language'
export const TOGGLE_STEPS_LIST = 'toggle_steps_list'
export const TOGGLE_RESPONSES_LIST = 'toggle_responses_list'
export const SELECT_RESPONSE = 'select_response'
export const TOGGLE_SIDE_NAV = 'toggle_side_nav'
export const SELECT_FEATURE = 'select_feature'
export const SELECT_MODE = 'select_mode'

export const UPDATE_PREV_SUCC_STEP = 'update_prev_successful_step'
export const SELECT_STEP = 'select_step'

export const RESET_CONFIGURATION = 'reset_configuration'
export const UPDATE_STORE_ID = 'update_store_id'
export const UPDATE_API_TOKEN = 'update_api_token'
export const UPDATE_ORDER_ID = 'update_order_id'
export const UPDATE_PAN = 'update_pan'
export const UPDATE_AMOUNT = 'update_amount'
export const UPDATE_EXPDATE = 'update_expdate'
export const UPDATE_CURRENCY = 'update_currency'
export const UPDATE_TXN_NUMBER = 'update_txn_number'
export const UPDATE_ECR_NUMBER = 'update_ecr_number'
export const UPDATE_MCP_RATE_TOKEN = 'update_mcp_rate_token'
export const CLEAR_HISTORY = 'clear_history'
export const UPDATE_ON_EDIT_ID = 'update_on_edit_id'

// ------------------ PROGRAMMING LANGUAGES -------------------
export const _DOTNET = 0
export const _JAVA = 1
export const _PHP = 2

//  ------------------------ FEATURES ------------------------
export const _COMMON = 'common'
export const _BASIC_TRANSACTIONS = 'b_trans'
export const _3DS2 = '3ds2'
export const _VAULT = 'v_admin'
export const _VAULTFINANCIAL = 'v_fin'
export const _RECURRING_BILLING = 'rec_billing'
export const _MCP = 'mcp'
export const _MCO = 'checkout'

// ------------------------ BASIC TRANSACTIONS SET ---------------------------- //
export const PURCHASE_SENT = 'purchase_sent'
export const PURCHASE_SUCCESS = 'purchase_success'
export const PURCHASE_FAIL = 'purchase_fail'

export const PREAUTH_SENT = 'preauth_sent'
export const PREAUTH_SUCCESS = 'preauth_success'
export const PREAUTH_FAIL = 'preauth_fail'

export const PREAUTH_COMPLETION_SENT = 'preauth_completion_sent'
export const PREAUTH_COMPLETION_SUCCESS = 'preauth_completion_success'
export const PREAUTH_COMPLETION_FAIL = 'preauth_completion_fail'

export const FORCE_POST_SENT = 'force_post_sent'
export const FORCE_POST_SUCCESS = 'force_post_success'
export const FORCE_POST_FAIL = 'force_post_fail'

export const INDEPENDENT_REFUND_SENT = 'independent_refund_sent'
export const INDEPENDENT_REFUND_SUCCESS = 'independent_refund_success'
export const INDEPENDENT_REFUND_FAIL = 'independent_refund_fail'

export const CARD_VERIFICATION_SENT = 'card_verification_sent'
export const CARD_VERIFICATION_SUCCESS = 'card_verification_success'
export const CARD_VERIFICATION_FAIL = 'card_verification_fail'

export const REFUND_SENT = 'refund_sent'
export const REFUND_SUCCESS = 'refund_success'
export const REFUND_FAIL = 'refund_fail'

export const PURCHASE_CORRECTION_SENT = 'purchase_correction_sent'
export const PURCHASE_CORRECTION_SUCCESS = 'purchase_correction_success'
export const PURCHASE_CORRECTION_FAIL = 'purchase_correction_fail'

export const OPEN_TOTALS_SENT = 'open_totals_sent'
export const OPEN_TOTALS_SUCCESS = 'open_totals_success'
export const OPEN_TOTALS_FAIL = 'open_totals_fail'

export const BATCH_CLOSE_SENT = 'batch_close_sent'
export const BATCH_CLOSE_SUCCESS = 'batch_close_success'
export const BATCH_CLOSE_FAIL = 'batch_close_fail'


// ------------------------ 3DS 2.0 Types ---------------------------- //

export const TOGGLE_STEPS_LIST_3DS2 = 'toggle_steps_list_3DS2'
export const SELECT_STEP_3DS2 = 'select_step_3ds2'
export const TOGGLE_RESPONSE_LIST_3DS2 = 'toggle_response_list_3ds2'
export const SELECT_RESPONSE_3DS2 = 'select_response_3ds2'
export const UPDATE_NEXT_STEP = 'update_next_step'
export const SELECT_MODE_3DS2 = 'select_mode_3ds2'
export const CHALLENGE_MADE = 'challenge_made'
export const TOGGLE_CHALLENGE_IFRAM = 'toggle_challenge_ifram'

export const RESET_CONFIGURATION_3DS2 = 'reset_configuration_3ds2'
export const UPDATE_STORE_ID_3DS2 = 'update_store_id_3ds2'
export const UPDATE_API_TOKEN_3DS2 = 'update_api_token_3ds2'
export const UPDATE_NOTIFICATION_URL = 'update_notification_url'
export const UPDATE_CAVV = 'update_cavv'
export const UPDATE_ECI = 'update_eci'
export const UPDATE_CHALLENGE_URL = 'update_challenge_url'
export const UPDATE_CHALLENGE_DATA = 'update_challenge_data'
export const UPDATE_CRES = 'update_cres'

export const CARD_LOOKUP_REQUEST_SENT = 'card_lookup_request_sent'
export const CARD_LOOKUP_REQUEST_SUCCESS = 'card_lookup_request_success'
export const CARD_LOOKUP_REQUEST_FAIL = 'card_lookup_request_fail'

export const AUTH_REQUEST_SENT = 'auth_request_sent'
export const AUTH_REQUEST_SUCCESS = 'auth_request_success'
export const AUTH_REQUEST_FAIL = 'auth_request_fail'

export const CAVV_LOOKUP_REQUEST_SENT = 'cavv_lookup_request_sent'
export const CAVV_LOOKUP_REQUEST_SUCCESS = 'cavv_lookup_request_success'
export const CAVV_LOOKUP_REQUEST_FAIL = 'cavv_lookup_request_fail'

export const CAVV_PURCHASE_REQUEST_SENT = 'cavv_purchase_request_sent'
export const CAVV_PURCHASE_REQUEST_SUCCESS = 'cavv_purchase_request_success'
export const CAVV_PURCHASE_REQUEST_FAIL = 'cavv_purchase_request_fail'

export const CAVV_PREAUTH_REQUEST_SENT = 'cavv_preauth_request_sent'
export const CAVV_PREAUTH_REQUEST_SUCCESS = 'cavv_preauth_request_success'
export const CAVV_PREAUTH_REQUEST_FAIL = 'cavv_preauth_request_fail'

export const RES_CAVV_PURCHASE_REQUEST_SENT = 'res_cavv_purchase_request_sent'
export const RES_CAVV_PURCHASE_REQUEST_SUCCESS = 'res_cavv_purchase_request_success'
export const RES_CAVV_PURCHASE_REQUEST_FAIL = 'res_cavv_purchase_request_fail'

export const RES_CAVV_PREAUTH_REQUEST_SENT = 'res_cavv_preauth_request_sent'
export const RES_CAVV_PREAUTH_REQUEST_SUCCESS = 'res_cavv_preauth_request_success'
export const RES_CAVV_PREAUTH_REQUEST_FAIL = 'res_cavv_preauth_request_fail'

export const CAVV_PURCHASE_REC_REQUEST_SENT = 'cavv_purchase_rec_request_sent'
export const CAVV_PURCHASE_REC_REQUEST_SUCCESS = 'cavv_purchase_rec_request_success'
export const CAVV_PURCHASE_REC_REQUEST_FAIL = 'cavv_purchase_rec_request_fail'

// ------------------------ MCP ---------------------------- //
export const GETRATE_SENT = 'get_rate_sent'
export const GETRATE_SUCCESS = 'get_rate_success'
export const GETRATE_FAIL = 'get_rate_fail'

export const PURCHASE_WITH_VAULT_SENT = 'purchase_with_vault_sent'
export const PURCHASE_WITH_VAULT_SUCCESS = 'purchase_with_vault_success'
export const PURCHASE_WITH_VAULT_FAIL = 'purchase_with_vault_fail'

export const PREAUTH_WITH_VAULT_SENT = 'preauth_with_vault_sent'
export const PREAUTH_WITH_VAULT_SUCCESS = 'preauth_with_vault_success'
export const PREAUTH_WITH_VAULT_FAIL = 'preauth_with_vault_fail'

export const INDREFUND_WITH_VAULT_SENT = 'indrefund_with_vault_sent'
export const INDREFUND_WITH_VAULT_SUCCESS = 'indrefund_with_vault_success'
export const INDREFUND_WITH_VAULT_FAIL = 'indrefund_with_vault_fail'

export const PURCHASE_3DS_SENT = 'purchase_3ds_sent'
export const PURCHASE_3DS_SUCCESS = 'purchase_3ds_success'
export const PURCHASE_3DS_FAIL = 'purchase_3ds_fail'

export const PURCHASE_3DS_VAULT_SENT = 'purchase_3ds_vault_sent'
export const PURCHASE_3DS_VAULT_SUCCESS = 'purchase_3ds_vault_success'
export const PURCHASE_3DS_VAULT_FAIL = 'purchase_3ds_vault_fail'

export const PREAUTH_3DS_SENT = 'preauth_3ds_sent'
export const PREAUTH_3DS_SUCCESS = 'preauth_3ds_success'
export const PREAUTH_3DS_FAIL = 'preauth_3ds_fail'

export const PREAUTH_3DS_VAULT_SENT = 'preauth_3ds_vault_sent'
export const PREAUTH_3DS_VAULT_SUCCESS = 'preauth_3ds_vault_success'
export const PREAUTH_3DS_VAULT_FAIL = 'preauth_3ds_vault_fail'

// ------------------------ Recurring Billing Transaction ---------------------------- //
export const RECURRING_PURCHASE_SENT = 'recurring_purchase_sent'
export const RECURRING_PURCHASE_SUCCESS = 'recurring_purchase_success'
export const RECURRING_PURCHASE_FAIL = 'recurring_purchase_fail'

export const RECURRING_UPDATE_SENT = 'recurring_update_sent'
export const RECURRING_UPDATE_SUCCESS = 'recurring_update_success'
export const RECURRING_UPDATE_FAIL = 'recurring_update_fail'

// ------------------------ Vault Transaction ---------------------------- //
export const VAULT_RESADDCC_SENT = 'vault_resaddcc_sent'
export const VAULT_RESADDCC_SUCCESS = 'vault_resaddcc_success'
export const VAULT_RESADDCC_FAIL = 'vault_resaddcc_fail'

export const VAULT_RESTEMPADD_SENT = 'vault_restempadd_sent'
export const VAULT_RESTEMPADD_SUCCESS = 'vault_restempadd_success'
export const VAULT_RESTEMPADD_FAIL = 'vault_restempadd_fail'

export const VAULT_RESUPDATECC_SENT = 'vault_resupdatecc_sent'
export const VAULT_RESUPDATECC_SUCCESS = 'vault_resupdatecc_success'
export const VAULT_RESUPDATECC_FAIL = 'vault_resupdatecc_fail'

export const VAULT_RESDELETE_SENT = 'vault_resdelete_sent'
export const VAULT_RESDELETE_SUCCESS = 'vault_resdelete_success'
export const VAULT_RESDELETE_FAIL = 'vault_resdelete_fail'

export const VAULT_RESLOOKUPFULL_SENT = 'vault_reslookupfull_sent'
export const VAULT_RESLOOKUPFULL_SUCCESS = 'vault_reslookupfull_success'
export const VAULT_RESLOOKUPFULL_FAIL = 'vault_reslookupfull_fail'

export const VAULT_RESLOOKUPMASK_SENT = 'vault_reslookupmask_sent'
export const VAULT_RESLOOKUPMASK_SUCCESS = 'vault_reslookupmask_success'
export const VAULT_RESLOOKUPMASK_FAIL = 'vault_reslookupmask_fail'

export const VAULT_RESGETEXPIRING_SENT = 'vault_resgetexpiring_sent'
export const VAULT_RESGETEXPIRING_SUCCESS = 'vault_resgetexpiring_success'
export const VAULT_RESGETEXPIRING_FAIL = 'vault_resgetexpiring_fail'

export const VAULT_RESISCORPORATEDCARD_SENT = 'vault_resiscorporatedcard_sent'
export const VAULT_RESISCORPORATEDCARD_SUCCESS = 'vault_resiscorporatedcard_success'
export const VAULT_RESISCORPORATEDCARD_FAIL = 'vault_resiscorporatedcard_fail'

export const VAULT_RESADDTOKEN_SENT = 'vault_resaddtoken_sent'
export const VAULT_RESADDTOKEN_SUCCESS = 'vault_resaddtoken_success'
export const VAULT_RESADDTOKEN_FAIL = 'vault_resaddtoken_fail'

export const VAULT_RESTOKENIZECC_SENT = 'vault_restokenizecc_sent'
export const VAULT_RESTOKENIZECC_SUCCESS = 'vault_restokenizecc_success'
export const VAULT_RESTOKENIZECC_FAIL = 'vault_restokenizecc_fail'

export const VAULT_RESPURCHASECC_SENT = 'vault_respurchasecc_sent'
export const VAULT_RESPURCHASECC_SUCCESS = 'vault_respurchasecc_success'
export const VAULT_RESPURCHASECC_FAIL = 'vault_respurchasecc_fail'

export const VAULT_RESPREAUTHCC_SENT = 'vault_respreauthcc_sent'
export const VAULT_RESPREAUTHCC_SUCCESS = 'vault_respreauthcc_success'
export const VAULT_RESPREAUTHCC_FAIL = 'vault_respreauthcc_fail'

export const VAULT_RESINDREFUNDCC_SENT = 'vault_resindrefundcc_sent'
export const VAULT_RESINDREFUNDCC_SUCCESS = 'vault_resindrefundcc_success'
export const VAULT_RESINDREFUNDCC_FAIL = 'vault_resindrefundcc_fail'

export const VAULT_RESFORCEPOSTCC_SENT = 'vault_resforcepostcc_sent'
export const VAULT_RESFORCEPOSTCC_SUCCESS = 'vault_resforcepostcc_success'
export const VAULT_RESFORCEPOSTCC_FAIL = 'vault_resforcepostcc_fail'

export const VAULT_CARDVERIFICATION_SENT = 'vault_cardverification_sent'
export const VAULT_CARDVERIFICATION_SUCCESS = 'vault_cardverification_success'
export const VAULT_CARDVERIFICATION_FAIL = 'vault_cardverification_fail'


// ------------------------ Checkout Types ---------------------------- //

export const OPEN_ALL_TABLES = 'open_all_tables'

export const SELECT_MODE_CHECKOUT = 'select_mode_checkout'
export const UPDATE_TXN_TOTAL = 'update_txn_total'
export const SET_PRELOAD_REQEUST_MESSAGE = 'set_preload_reqeust_message'

export const SET_SHOW_CALLBACK_CONSOLE = 'set_show_callback_console'
export const SET_NOT_SHOW_CALLBACK_CONSOLE = 'set_not_show_callback_console'

export const UPDATE_RECEIPT_CHECKOUT = 'update_receipt_checkout'
export const UPDATE_TICKET_CHECKOUT = 'update_ticket_checkout'

export const SELECT_NOT_DISPLAY_IFRAME = 'select_not_display_iframe'
export const SELECT_IF_DISPLAY_IFRAME = 'select_if_display_iframe'

export const SELECT_LEFT_SAMPLE_SHOW = 'select_left_sample_show'
export const SELECT_RIGHT_SAMPLE_SHOW = 'select_right_sample_show'

export const CHECKOUT_RECEIPT_SENT = 'checkout_receipt_sent'
export const CHECKOUT_RECEIPT_SUCCESS = 'checkout_receipt_success'
export const CHECKOUT_RECEIPT_FAIL = 'checkout_receipt_fail'

export const CHECKOUT_PRELOAD_REQUEST_SENT = 'checkout_preload_request_sent'
export const CHECKOUT_PRELOAD_REQUEST_SUCCESS = 'checkout_preload_request_success'
export const CHECKOUT_PRELOAD_REQUEST_FAIL = 'checkout_preload_request_fail'

export const SELECT_STEP_CHECKOUT = 'select_step_checkout'
export const SELECT_RESPONSE_CHECKOUT = 'select_response_checkout'
export const TOGGLE_STEPS_LIST_CHECKOUT = 'toggle_steps_list_checkout'
export const TOGGLE_RESPONSE_LIST_CHECKOUT = 'toggle_response_list_checkout'

export const UPDATE_STORE_ID_CHECKOUT = 'update_store_id_Checkout'
export const UPDATE_API_TOKEN_CHECKOUT = 'update_api_token_Checkout'
export const UPDATE_CHECKOUT_ID_CHECKOUT = 'update_checkout_id_Checkout'
export const RESET_CONFIGURATION_CHECKOUT= 'reset_configuration_Checkout'

export const SET_TERMINATE_CHECKOUT = 'set_terminate_checkout'
export const SET_NOT_TERMINATE_CHECKOUT = 'set_not_terminate_checkout'
export const SET_DISPLAY_CHECKOUT = 'set_display_checkout'
export const SET_NOT_DISPLAY_CHECKOUT = 'set_not_display_checkout'

export const UPDATE_CALLBACK_CONSOLE = 'update_callback_console'

export const UPDATDE_FIRST_FIELD = 'update_first_field'
export const UPDATDE_SECOND_FIELD = 'update_second_field'
export const UPDATDE_THIRD_FIELD = 'update_third_field'





